import { atom } from 'recoil';

export const ShowSlideBarState = atom({
    key: 'ShowSlideBarState', 
    default: false, 
});